export const partnerPaymentSettings = {
    title: 'ברוכים הבאים לבלינק {{partnerName}}',
    paymentMethodSelector: {
        title: 'פרטי אמצעי תשלום',
        noPaymentMethod: 'חסר אמצעי תשלום',
        addMethod: 'הוספת אמצעי תשלום'
    },
    paymentMethodModal: {
        title: 'בחירת אמצעי התשלום',
        description: 'את התשלום עבור תוספות המערכת ניתן לבצע באמצעות כרטיס אשראי או באמצעות קיזוז מההעברה המתוכננת לחשבון',
        creditCard: 'כרטיס אשראי',
        fromTransfer: 'קיזוז מהעברה'
    },
    systemFeatures: {
        title: 'תוספות מערכת',
        completeSystem:  {
            label: 'מערכת מלאה',
            description: '25 ש״ח לבניין עבור מערכת מלאה ללא הגבלת פיצ׳רים',
        },
        greenInvoice:  {
            label: 'חשבונית ירוקה',
            description: 'תשלום חודשי לפי הסכם התקשרות, ללא הגבלת בניינים או מסמכים',
        },
        maintenance:  {
            label: 'תחזוקה',
            description: 'תשלום חודשי לפי הסכם התקשרות',
        },
        checkScanner:  {
            label: 'סורק שיקים',
            description: 'תשלום חודשי לפי הסכם התקשרות',
        },
        active: 'פעיל',
        disabled: 'לא פעיל',
        actions: {
            add: 'הוספה'
        }
    },
    notifications: {
        paymentMethodEstablished: 'הוקמה אמצעי תשלום חדש'
    }
};
